import * as React from 'react';
import {
  SiteMembers,
  MembersActions,
  SiteMembersWithActions,
  SiteMembersContext,
  PendingMembers,
} from './SiteMembers';
export interface WithSiteMembers
  extends MembersActions,
    SiteMembers,
    PendingMembers {}
export const withSiteMembers = <P extends WithSiteMembers>(
  WrappedComponent: React.ComponentType<P>,
) => props => {
  return (
    <SiteMembersContext.Consumer>
      {({
        siteMembers,
        siteMembersMap,
        membersQueryResponse,
        currentSiteMember,
        membersActions,
        pendingMembers,
      }: SiteMembersWithActions) => (
        <WrappedComponent
          {...props}
          membersQueryResponse={membersQueryResponse}
          siteMembers={siteMembers}
          siteMembersMap={siteMembersMap}
          currentSiteMember={currentSiteMember}
          pendingMembers={pendingMembers}
          {...membersActions}
        />
      )}
    </SiteMembersContext.Consumer>
  );
};
